/* tslint:disable:typedef-whitespace align no-trailing-whitespace */

import { Action, ActionType    } from '@/models/action';
import { ModalService          } from '@/services/modal.service';

/**
 *
 * @class ProjectNewAction
 *
 * @brief create an entirely new project
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class ProjectNewAction extends Action {

  private modals: ModalService        = null;

  constructor(options: any = null) {

    super({
      key:   'project.new',
      type:  ActionType.Project_New,
      label: 'New',
      icon:  '<i class="fas fa-plus"></i>',
      tip:   'Create an entirely new project'
    });

    this.modals   = this.injector().get(ModalService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    this.modals.open('new-project-modal');

    return true;
  }
}
